import { Dispatch, createContext, useReducer } from "react";
import { UserContent, userReducer, UserReducerAction } from "../reducers/userReducer";

interface UserContextInterface {
  userState: UserContent;
  userDispatch: Dispatch<UserReducerAction>;
}

const UserDafaultState = {
  userState: {},
  userDispatch: () => {},
};

export const UserContext = createContext<UserContextInterface>(UserDafaultState);

const UserContextProvider = ({ children }: {children: JSX.Element}) => {
  const [userState, userDispatch] = useReducer(userReducer, {});
  return (
    <UserContext.Provider value={ { userState, userDispatch } }>
      { children }
    </UserContext.Provider>
  );
};

export default UserContextProvider;
